import { render, staticRenderFns } from "./AddTrainingEventsCategoryModal.vue?vue&type=template&id=65b247d6&"
import script from "./AddTrainingEventsCategoryModal.vue?vue&type=script&lang=js&"
export * from "./AddTrainingEventsCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports